export const katakanaRegex = /^[\u30A0-\u30FFー 　]+$/; // include hyphen, space, and full-width space
